import styled from "styled-components";

const InsytixEmployeesSc = styled.div`
  padding: 24px 32px 48px;
  color: #1f1f1f;

  h1 {
    margin: 0;
    font-size: 1.6rem;
    color: #ffffff;
  }

  .page-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 16px;
    margin-bottom: 16px;
  }

  .subtitle {
    margin: 4px 0 0;
    color: #ffffff;
  }

  .toolbar {
    display: flex;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 12px;
  }

  input,
  .search {
    border: 1px solid #d0d0d0;
    border-radius: 6px;
    padding: 8px 10px;
    width: 100%;
  }

  .search {
    max-width: 320px;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    background: white;
  }

  th,
  td {
    border-bottom: 1px solid #ececec;
    text-align: left;
    padding: 10px 12px;
    vertical-align: middle;
  }

  th {
    background: #2d3592;
    color: #ffffff;
    border-bottom: 1px solid #2d3592;
    font-weight: 600;
  }

  .actions {
    display: flex;
    gap: 8px;
  }

  button {
    border: 0;
    border-radius: 6px;
    padding: 8px 12px;
    cursor: pointer;
  }

  .primary {
    background: #6f2d89;
    color: white;
  }

  .secondary {
    background: #ece7f1;
    color: #3a1d4a;
  }

  .danger {
    background: #a4274f;
    color: white;
  }

  .form-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 12px;
  }

  label {
    display: flex;
    flex-direction: column;
    gap: 4px;
    font-size: 0.9rem;
  }

  .message {
    padding: 24px 0;
    color: #ffffff;
  }
`;

export default InsytixEmployeesSc;
